import LoginHistory from "metabase/entities/loginHistory";

import LoginHistoryList from "../../components/LoginHistory";

export default LoginHistory.loadList()(LoginHistoryList);
